import { Divider, Typography } from '@mui/material';
import styles from './ContainerTitle.styles';

interface ContainerTitleComponentProps {
  title: string;
}

const ContainerTitleComponent = function ({ title }: ContainerTitleComponentProps): JSX.Element {
  return (
    <>
      <Typography variant="h5" color="rgba(0,0,0,0.495)" fontWeight={300} marginBottom={1}>
        {title}
      </Typography>

      <Divider sx={styles.divider} />
    </>
  );
};

export default ContainerTitleComponent;
